import { Badge } from '@antimatterhq/ui/components/badge';

interface DataSourceEnabledBadgeProps {
  enabled: boolean;
  'data-testid'?: string;
}

export const DataSourceEnabledBadge = ({
  enabled,
  'data-testid': testId,
}: DataSourceEnabledBadgeProps) => {
  return (
    <span data-testid={testId} data-enabled={enabled}>
      {enabled ? (
        <Badge variant="filled" color="success">
          Enabled
        </Badge>
      ) : (
        <Badge variant="filled" color="danger">
          Disabled
        </Badge>
      )}
    </span>
  );
};
